// Select2 JS é carregado via script tag em index.html
// Select2 CSS é carregado via import abaixo
// jQuery já está disponível globalmente via vendors.min.js

import $ from 'jquery';
import 'select2/dist/css/select2.min.css';

// Garante que jQuery está disponível globalmente
window.$ = window.$ || $;
window.jQuery = window.jQuery || $;

export default $;
